import React, { useState } from 'react';
import { crearCategoriaServicio } from '../services/serviciosService';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';

// Mini-formulario para crear una categoría de SERVICIO sin salir del formulario
// del servicio. El prefijo genera los códigos correlativos (ej. VJE → VJE-0001).

const P = 'var(--color-primario,#DB2777)';
const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
const EMOJIS = ['🧰', '✈️', '🏖️', '🏗️', '⚖️', '🩺', '💻', '🖨️', '🧹', '📸', '🎨', '📚', '🔧', '🚗'];

export default function NuevaCategoriaServicioInline({ onCreada, onCerrar }) {
  const { mostrarToast } = useToast();
  const [nombre, setNombre] = useState('');
  const [prefijo, setPrefijo] = useState('');
  const [icono, setIcono] = useState('🧰');
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    if (nombre.trim().length < 2) { mostrarToast('Escribe el nombre de la categoría', 'error'); return; }
    setGuardando(true);
    try {
      const cat = await crearCategoriaServicio({ nombre, prefijo, icono });
      mostrarToast('Categoría creada ✅', 'exito');
      onCreada(cat);
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1400, padding: '16px' }} onClick={onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', padding: '22px', width: '380px', maxWidth: '100%', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
          <h3 style={{ margin: 0, color: P, fontSize: '17px' }}>Nueva categoría de servicio</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>
        <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 600, color: '#374151' }}>Nombre *</label>
        <input value={nombre} maxLength={60} disabled={guardando} onChange={(e) => setNombre(e.target.value)} style={{ ...input, marginBottom: '12px' }} placeholder="Ej. Paquetes de viaje" />
        <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 600, color: '#374151' }}>Prefijo del código (opcional)</label>
        <input value={prefijo} maxLength={5} disabled={guardando} onChange={(e) => setPrefijo(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))} style={{ ...input, marginBottom: '12px' }} placeholder="Ej. VJE" />
        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#374151' }}>Ícono</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '18px' }}>
          {EMOJIS.map((e) => (
            <button key={e} type="button" onClick={() => setIcono(e)}
              style={{ fontSize: '20px', padding: '6px', borderRadius: '8px', cursor: 'pointer', border: icono === e ? `2px solid ${P}` : '1px solid #E5E7EB', background: icono === e ? 'color-mix(in srgb, var(--color-primario,#DB2777) 8%, white)' : '#fff' }}>{e}</button>
          ))}
        </div>
        <button onClick={guardar} disabled={guardando}
          style={{ width: '100%', padding: '12px', background: guardando ? '#9CA3AF' : P, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
          {guardando ? '⏳ Guardando…' : 'Crear categoría'}
        </button>
      </div>
    </div>
  );
}
